import { Button, CloseIconButton } from '@library/components/buttons';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { classNames } from '@library/utils';

interface SidebarProps {
  children: React.ReactNode;
}

export const Sidebar = ({ children }: SidebarProps) => {
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);

  return (
    <section>
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-40 lg:hidden"
          onClose={setSidebarOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0" />
          </Transition.Child>
          <div className="fixed inset-0 flex">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="bg-soFresh-100 relative mr-16 mt-16 flex w-full max-w-[212px] flex-1">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute right-0 top-[-.5rem] flex w-10 justify-center pt-5">
                    <CloseIconButton
                      className="-m-1 p-1"
                      handleOnClick={() => setSidebarOpen(false)}
                    />
                  </div>
                </Transition.Child>
                <div className="no-scrollbar text-soClean-100 flex grow flex-col gap-y-5 overflow-y-auto ring-1 ring-white/10">
                  {children}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>

      <div className="bg-muted lg:border-soFresh-130 hidden w-[212px] lg:fixed lg:z-40 lg:flex lg:flex-col lg:border-r">
        {/* Sidebar component, swap this element with another sidebar if you like */}
        <div className="text-soClean-100 no-scrollbar flex h-screen grow flex-col gap-y-5 pb-4">
          {children}
        </div>
      </div>
      <div className="bg-soFresh-100 lg:pl-56">
        <div className="shadow-xs fixed z-20 flex h-16 shrink-0 items-center gap-x-4 px-4 sm:gap-x-6 sm:px-6 lg:hidden lg:px-8">
          <Button
            title="ToggleSideBarButton"
            type="button"
            className={classNames(
              'text-soFresh-140 fixed top-0 z-30 -m-2.5 p-2.5 py-7',
              sidebarOpen ? 'hidden' : ''
            )}
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <Bars3Icon className="size-6" aria-hidden="true" />
          </Button>
        </div>
      </div>
    </section>
  );
};
